import { GetterTree } from "vuex";
import { UserManagementState, UserDetails } from "./types";
import { RootState } from "@/store/types";

export const userManagementGetters: GetterTree<UserManagementState, RootState> = {
	getPermissions: state => state.permissions,
	getUserRoles: state => state.userRoles,
	getUsersDomains: state => state.userDomains,
	getDomainGroups: state => state.domainGroups,
	getUserGroupById: state => (id: number) => state.userGroups.find(ur => ur.userGroupId === id),
	getAllUsersRetrieved: state => { return state.allUsersRetrieved; },
	getDomain: state => (domainId: number) => state.domains.find(d => d.domainId === domainId)
};
